/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_PROVENANCE_DETAILS = gql`
    query GetProvenance($provenanceId: String!) {
        getProvenance(provenanceId: $provenanceId) {
            _id
            name
            description
            creatorUser
            product {
                _id
                name
            }
            batch {
                _id
                name
              }
            provSteps {
                credTxs {
                    _id
                    createdAt
                    updatedAt
                    vcTag
                    credentialTemplate {
                        credentialContent {
                            credentialSubject
                            evidences
                        }
                        templateId
                        description
                        labelKey
                        name
                        _id
                        getAllClaimKeys {
                            keys
                        }
                    }
                    credential {
                        _id
                        createdAt
                        updatedAt
                        tag
                        name
                        from
                        state
                        to
                        type
                        issuer {
                            organization {
                                sameAs
                                _id
                                telephone
                                description
                                name
                                email
                                creator
                                fullAddress
                                logo
                                image
                                createdAt
                                updatedAt
                                provCredentials {
                                    createdAt
                                    _id
                                    updatedAt
                                    vcTag
                                }
                            }
                        }
                    }
                    credentialContent {
                        evidences
                        credentialSubject
                        images
                    }
                    credentialSubjectKeyVals {
                        label
                        values
                        value
                        key
                    }
                }
                parentCredTx {
                    credentialContent {
                        evidences
                        credentialSubject
                        images
                    }
                    credentialSubjectKeyVals {
                        value
                        key
                        values
                        label
                    }
                    credentialTemplate {
                        description
                        labelKey
                        name
                        _id
                        templateId
                        credentialContent {
                            evidences
                            credentialSubject
                        }
                        getAllClaimKeys {
                            keys
                        }
                    }
                    vcTag
                }
                title
                subtitle
            }
            provenanceTemplate
        }
    }
`;
